// Icons Import
import { FaArrowRight } from "react-icons/fa"
import { Link } from "react-router-dom"

// Image and Video Import
import Banner from "../assets/Images/banner.mp4"
// Component Imports
import Footer from "../components/Common/Footer"
import ReviewSlider from "../components/Common/ReviewSlider"
import CTAButton from "../components/core/HomePage/Button"
import CodeBlocks from "../components/core/HomePage/CodeBlocks"
import ExploreMore from "../components/core/HomePage/ExploreMore"
import HighlightText from "../components/core/HomePage/HighlightText"
import InstructorSection from "../components/core/HomePage/InstructorSection"
import LearningLanguageSection from "../components/core/HomePage/LearningLanguageSection"
import TimelineSection from "../components/core/HomePage/Timeline"

function Home() {
  return (
    <div className="gen-container bg-[#f0f4f5]">
      {/* Section 1 */}
      <div className="relative flex   flex-col items-center justify-between gap-8 text-white">
        {/* Become a Instructor Button */}
        {/* <Link to={"/signup"}>
          <div className="group mx-auto mt-16 w-fit rounded-full bg-richblack-800 p-1 font-bold text-richblack-200 drop-shadow-[0_1.5px_rgba(255,255,255,0.25)] transition-all duration-200 hover:scale-95 hover:drop-shadow-none">
            <div className="flex flex-row items-center gap-2 rounded-full px-10 py-[5px] transition-all duration-200 group-hover:bg-richblack-900">
              <p>Enroll Now</p>
              <FaArrowRight />
            </div>
          </div>
        </Link> */}
        <section className=" section sec-1 bv-w m-auto flex items-center">
          {/* Heading */}
        <div className="container">
        <div className="xd-outer vb xg-k "></div>
          <div className="xd-shape1 vb xg-k"></div>
          <div className="relative w-1/2 items-center">
            <div className=" main-heading mb-6  text-left text-[64px]">
              A Little Piece of Doggy Heaven
            </div>
            {/* Sub Heading */}
            <p className="sub-heading -mt-3 w-[90%] text-left  text-base text-white">
              Looking for a well-behaved furry friend? Look no further than
              Company Thapar Dog school, your trusted dog trainer. Our expert
              trainers will help your dog become the best version of themselves.
            </p>
            {/* CTA Buttons */}
            <div className="mt-8 flex flex-row gap-7">
              {/* <CTAButton active={true} linkto={"/signup"}>
          Learn More
        </CTAButton> */}
              <CTAButton active={false} linkto={"/catalog/courses"}>
                Courses
                <svg
                  className="svg-btn"
                  stroke="#212529"
                  fill="#212529"
                  stroke-width="0.4"
                  viewBox="0 0 20 20"
                  height="19px"
                  width="18px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                  ></path>
                </svg>
              </CTAButton>
            </div>
          </div>
          <a className="swipe-up" href="#thanks"><span></span><span></span><span></span>swipe up</a>
        </div>

        </section>
      

        {/* Code Section 1  */}
        {/* <div>
          <CodeBlocks
            position={"lg:flex-row"}
            heading={
              <div className="text-4xl font-semibold">
                Unlock your
                <HighlightText text={"coding potential"} /> with our online
                courses.
              </div>
            }
            subheading={
              "Our courses are designed and taught by industry experts who have years of experience in coding and are passionate about sharing their knowledge with you."
            }
            ctabtn1={{
              btnText: "Try it Yourself",
              link: "/signup",
              active: true,
            }}
            ctabtn2={{
              btnText: "Learn More",
              link: "/signup",
              active: false,
            }}
            codeColor={"text-yellow-25"}
            codeblock={`<!DOCTYPE html>\n <html lang="en">\n<head>\n<title>This is myPage</title>\n</head>\n<body>\n<h1><a href="/">Header</a></h1>\n<nav> <a href="/one">One</a> <a href="/two">Two</a> <a href="/three">Three</a>\n</nav>\n</body>`}
            backgroundGradient={<div className="codeblock1 absolute"></div>}
          />
        </div> */}
      

        {/* Code Section 2 */}
        {/* <div>
          <CodeBlocks
            position={"lg:flex-row-reverse"}
            heading={
              <div className="w-[100%] text-4xl font-semibold lg:w-[50%]">
                Start
                <HighlightText text={"coding in seconds"} />
              </div>
            }
            subheading={
              "Go ahead, give it a try. Our hands-on learning environment means you'll be writing real code from your very first lesson."
            }
            ctabtn1={{
              btnText: "Continue Lesson",
              link: "/signup",
              active: true,
            }}
            ctabtn2={{
              btnText: "Learn More",
              link: "/signup",
              active: false,
            }}
            codeColor={"text-white"}
            codeblock={`import React from "react";\n import CTAButton from "./Button";\nimport TypeAnimation from "react-type";\nimport { FaArrowRight } from "react-icons/fa";\n\nconst Home = () => {\nreturn (\n<div>Home</div>\n)\n}\nexport default Home;`}
            backgroundGradient={<div className="codeblock2 absolute"></div>}
          />
        </div> */}

        {/* Explore Section */}
        {/* <ExploreMore /> */}
      </div>

      {/* Section 2 */}
      <section className=" section sec-2 py-16 ">
        <div className="xd-shape4 vb"></div>
          <div className="container">
          <div className="row items-center flex ">
            <div className="col-lg-6 pt16 pb16 w-1/2">
              <img
                src="https://dlvkyia8i4zmz.cloudfront.net/yndta5ZHQFaoAdlkyvd7_Mask_group__1_.png"
                width= "480" height = "320"
                loading="lazy"
              />
            </div>
            <div className="pt16 pb16 offset-lg-1 col-lg-5 w-1/2 ml-24 sm:ml-0">
              <h2>Training Programs</h2>
              <div
                className="s_hr pb32 pt8 text-start"
                data-snippet="s_hr"
                data-name="Separator"
              >
                <hr className="w-50 me-auto" />
              </div>
              <p className="mb-4 text-[#212529] font-light">
                Our team is composed of certified dog trainers with years of
                experience in the industry.
              </p>
              <p className="mb-10 text-[#212529] font-light">Fun and Educational Activities</p>
             <Link to='/about'>
              <button className="rounded-3xl px-5 py-2 bg-[#dbb4ac] text-[#212529] text-base "> Learn More</button>
             </Link>

            </div>
          </div>
          </div>
        </section>

      {/* Section 3 */}
      <section className="section sec-3 bg-white pt-28">
        <div className="xd-shape2 vb"> </div>
      <div className="container mx-auto">
      <div className="grid grid-cols-3 gap-4">
          <div className="card text-center p-4">
            <img src="https://dlvkyia8i4zmz.cloudfront.net/mIl1x9lHR4uiy5QHq3rT_Frame__6_.png" alt="" />
             <div className="card-body p-4">
              <h3 className="text-[#212529] text-3xl mb-2">Our mission</h3>
              <hr />
              <p className="card_text text-[#212529] font-light">  Our aim is to make your dog's training experience as enjoyable, rewarding, and positive as possible. </p>

             </div>
             </div>
             <div className="card text-center p-4">
            <img src="https://dlvkyia8i4zmz.cloudfront.net/uwnpM3IwS4ep2qcCD4Zm_Frame__9_.png" alt="" />
             <div className="card-body p-4">
              <h3 className="text-[#212529] text-3xl mb-2">For every kid</h3>
              <hr className="rex"/>
              <p className="card_text text-[#212529] font-light">  Our training programs are tailored to meet the unique needs of each dog, ensuring they reach their full potential. </p>

             </div>
          </div>
          <div className="card text-center p-4">
            <img src="https://dlvkyia8i4zmz.cloudfront.net/P1CEgTkiSim8k24gUmqe_Group_87.png" alt="" />
             <div className="card-body p-4">
              <h3 className="text-[#212529] text-3xl mb-2">Open Communication</h3>
              <hr />
              <p className="card_text text-[#212529] font-light"> Visit us anytime to meet our trainers and see our facilities.</p>

             </div>
          </div>
          </div>
       <div className="grid grid-cols-3 gap-8 py-24">
          <div className="sm-cards text-center">
         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46"><path d="M30.62,88a15,15,0,0,0,13.74,13c4.6.43,10.24.65,16.79.65,3.69,0,6.93-.07,9.18-.14,2.77,8.57,11.1,32.54,21.48,46,11.76,15.21,28.65,23.82,50.28,25.67v49.77a4.2,4.2,0,1,0,8.39,0v-49.4l.75,0c1,0,1.9,0,2.84-.06v49.44a4.2,4.2,0,1,0,8.4,0V172.69c12.92-2,24.1-7.55,32.71-16.34C207.32,144,213.5,125.86,213.06,104a4.21,4.21,0,0,0-4.2-4.11H121.68L90.11,57a4.19,4.19,0,0,0-4.78-1.47c-1.64.58-40.26,14.25-47.54,17.28C32.54,75,29.59,81.22,30.62,88ZM41,80.51C47,78,75.83,67.76,85.2,64.44l31,42.14a4.22,4.22,0,0,0,3.38,1.71h85.11c-.39,17.68-5.7,32.21-15.48,42.19-9.41,9.6-22.53,14.67-38,14.67-23.32,0-41.08-7.67-52.78-22.79s-21-46-21-46.34a4.2,4.2,0,0,0-4.22-3c-.05,0-5.35.24-12,.24-6.29,0-11.67-.21-16-.61a6.53,6.53,0,0,1-6.22-5.92C38.5,84,39.44,81.17,41,80.51Z" fill="#dbb4ac"/><path d="M113.4,238c0-11,16.71-19.25,38.88-19.25S191.16,227,191.16,238a4.2,4.2,0,0,1-4.2,4.2H117.59A4.2,4.2,0,0,1,113.4,238Zm38.88-10.85c-13.15,0-22.94,3.21-27.55,6.65h55.09C175.21,230.34,165.42,227.13,152.28,227.13Z"fill ="#0AA2C0"/><path d="M51.37,48.79c15.56-8.12,29.54-9.63,42.72-4.62,15.36,5.85,29.22,20.4,42.38,44.48a4.2,4.2,0,0,1-.69,5l-12,12.13c1.11,15,17.15,26.44,31,26.44,18.35,0,32.18-12.05,32.18-28.05,0-17.92,12.88-31.44,30-31.44a28.18,28.18,0,0,1,20.53,8.4c7.27,7.34,11,18.88,10.86,33.35-.35,31.75,3.18,42.92,4.27,45.58a5,5,0,0,1-1,5.59,5.89,5.89,0,0,1-4.37,1.62,19,19,0,0,1-7-1.73C227,160,204.68,140.9,204.66,104.09a4.2,4.2,0,0,1,4.2-4.2h0a4.2,4.2,0,0,1,4.2,4.2c0,23.27,9.65,37.34,17.73,45a43.11,43.11,0,0,0,12.34,8.47c-2.23-9.47-3.37-24.7-3.17-43.25.14-12.18-2.78-21.65-8.43-27.36A20,20,0,0,0,217,81.09c-12.29,0-21.56,9.9-21.56,23,0,20.44-17.82,36.45-40.58,36.45-18.62,0-39.45-15.58-39.47-36.45v0a1.79,1.79,0,0,1,0-.23,3.68,3.68,0,0,1,.06-.58c0-.13.07-.24.1-.37s.08-.28.13-.41a3.39,3.39,0,0,1,.2-.38,2.37,2.37,0,0,1,.19-.35,3.47,3.47,0,0,1,.35-.43,1.49,1.49,0,0,1,.15-.2l11-11.18c-26.11-46-50.26-44.14-69-35.37l4.9,13.1a4.2,4.2,0,1,1-7.86,2.94L49.38,54A4.2,4.2,0,0,1,51.37,48.79Z" fill = "#0AA2C0"/></svg>
          <a href="/about" className="text-[#07758b] text-base font-light ">About us</a>
          </div>
          {/* <div className="sm-cards text-center ">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46"><path d="M221.08,94.38H62.38a15.85,15.85,0,1,1,0-31.69h158.7a15.85,15.85,0,1,1,0,31.69ZM62.38,71.09a7.45,7.45,0,0,0,0,14.9h158.7a7.45,7.45,0,0,0,0-14.9Z" fill="#dbb4ac"/><path d="M43.55,223.6a4,4,0,0,1-.68,0,4.21,4.21,0,0,1-3.47-4.82l21-129.22a4.2,4.2,0,0,1,8.29,1.35l-21,129.22A4.19,4.19,0,0,1,43.55,223.6Z" fill="#dbb4ac"/><path d="M239.91,223.6a4.2,4.2,0,0,1-4.14-3.52l-21-129.22A4.2,4.2,0,0,1,223,89.51l21,129.22a4.2,4.2,0,0,1-3.47,4.82A3.89,3.89,0,0,1,239.91,223.6Z" fill="#dbb4ac"/><path d="M141.73,209.06A34.75,34.75,0,0,1,107,174.36v-8.07a4.2,4.2,0,0,1,4.2-4.2H126.3a4.21,4.21,0,0,1,4.2,4.2v8.07a11.24,11.24,0,0,0,22.47,0v-8.07a4.2,4.2,0,0,1,4.2-4.2h15.08a4.2,4.2,0,0,1,4.19,4.2v8.07A34.75,34.75,0,0,1,141.73,209.06Zm-26.31-38.57v3.87a26.32,26.32,0,0,0,52.63,0v-3.87h-6.68v3.87a19.64,19.64,0,0,1-39.27,0v-3.87Z" fill="#0AA2C0"/><path d="M118.36,170.49a4.2,4.2,0,0,1-4.2-4.2V63.22a4.2,4.2,0,0,1,8.4,0V166.29A4.2,4.2,0,0,1,118.36,170.49Z" fill="#0AA2C0"/><path d="M165.11,170.49a4.2,4.2,0,0,1-4.2-4.2V63.22a4.2,4.2,0,1,1,8.39,0V166.29A4.2,4.2,0,0,1,165.11,170.49Z" fill="#0AA2C0"/><path d="M62.72,224.44H24.38a4.2,4.2,0,1,1,0-8.39H62.72a4.2,4.2,0,1,1,0,8.39Z" fill="#0AA2C0"/><path d="M259.09,224.44H220.74a4.2,4.2,0,1,1,0-8.39h38.35a4.2,4.2,0,1,1,0,8.39Z" fill="#0AA2C0"/></svg>
          <a href="" className="text-[#07758b] text-base font-light">Our Team</a>
          </div> */}
          <div className="sm-cards text-center ">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46"><path d="M209.92,65.34a4.2,4.2,0,0,0-4.31.2c-9.33,6.18-18.66,3.09-29.46-.49-9.33-3.09-19.69-6.52-30.22-2.79v-5a4.2,4.2,0,0,0-8.4,0V69h0V107.5h0V152.3a4.2,4.2,0,1,0,8.4,0V109.92c8.71-4.65,17.51-1.74,27.58,1.6,6.43,2.13,13.35,4.42,20.47,4.42A28.61,28.61,0,0,0,210.25,111a4.17,4.17,0,0,0,1.88-3.49V69A4.2,4.2,0,0,0,209.92,65.34Zm-6.19,39.82c-8.71,4.65-17.5,1.73-27.58-1.61-9.33-3.1-19.69-6.52-30.22-2.79V71.42c8.71-4.65,17.5-1.74,27.58,1.6,9.33,3.1,19.69,6.53,30.22,2.8Z" fill="#0AA2C0"/><path d="M189.94,230.39a4.2,4.2,0,0,1-4.2-4.2V156.5h-9.28v7.56a4.2,4.2,0,0,1-4.2,4.19H153.75a4.2,4.2,0,0,1-4.2-4.19V156.5H133.91v7.56a4.2,4.2,0,0,1-4.2,4.19H111.2a4.2,4.2,0,0,1-4.19-4.19V156.5H97.72v69.69a4.2,4.2,0,0,1-8.4,0V152.3a4.2,4.2,0,0,1,4.2-4.2H111.2a4.2,4.2,0,0,1,4.2,4.2v7.56h10.11V152.3a4.2,4.2,0,0,1,4.2-4.2h24a4.2,4.2,0,0,1,4.2,4.2v7.56h10.11V152.3a4.2,4.2,0,0,1,4.2-4.2h17.68a4.2,4.2,0,0,1,4.2,4.2v73.89A4.2,4.2,0,0,1,189.94,230.39Z" fill="#dbb4ac"/><path d="M222.43,230.39H61A4.2,4.2,0,1,1,61,222h161.4a4.2,4.2,0,1,1,0,8.39Z" fill="#0AA2C0"/></svg>
          <a href="/catalog/courses" className="text-[#07758b] text-base font-light">Training Services</a>
          </div>
          {/* <div className="sm-cards text-center">
           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46"><path d="M139.86,137.13a2.84,2.84,0,1,0-5.67,0c0,8.78,1,11.58,6.38,17.57,4.1,4.59,5.55,12.23.16,17.34-10.06,9.54-9.31,21.78-8.77,30.72.11,1.85.22,3.59.22,5.13a2.84,2.84,0,1,0,5.68,0c0-1.71-.12-3.54-.23-5.48-.53-8.68-1.13-18.53,7-26.25s6-18.66.16-25.24C140.55,146.17,139.86,144.84,139.86,137.13Z" fill="#dbb4ac"/><path d="M181.55,195.27c2.73-5.34,1.83-15,1.72-16.11a2.84,2.84,0,1,0-5.65.58c.24,2.32.55,9.68-1.12,12.94-4.84,9.46-2.95,15.59-1.43,20.51a18.36,18.36,0,0,1,1.11,5.2,2.84,2.84,0,1,0,5.68,0,22.92,22.92,0,0,0-1.37-6.88C179.15,207.17,177.76,202.67,181.55,195.27Z" fill="#dbb4ac"/><path d="M105.84,191.33a2.84,2.84,0,0,0-5.65.58c.24,2.32.55,9.68-1.12,13-4.84,9.45-2.95,15.58-1.43,20.5a18.35,18.35,0,0,1,1.11,5.21,2.84,2.84,0,1,0,5.68,0,23.23,23.23,0,0,0-1.36-6.88c-1.35-4.35-2.73-8.85,1.05-16.24C106.85,202.1,106,192.42,105.84,191.33Z" fill="#dbb4ac"/><path d="M173.87,95c0-24.78-16.53-44.95-36.84-44.95s-36.85,20.17-36.85,45,16.53,45,36.85,45S173.87,119.8,173.87,95ZM137,134.29c-17.19,0-31.17-17.62-31.17-39.28s14-39.27,31.17-39.27S168.19,73.36,168.19,95,154.21,134.29,137,134.29Z" fill="#0AA2C0"/><path d="M119.16,95c0-7.6,2.54-14.67,7-19.37A2.84,2.84,0,0,0,122,71.75C116.58,77.5,113.48,86,113.48,95a37.61,37.61,0,0,0,1.84,11.74,2.84,2.84,0,0,0,2.69,2,2.76,2.76,0,0,0,.89-.14,2.83,2.83,0,0,0,1.81-3.58A32,32,0,0,1,119.16,95Z" fill="#0AA2C0"/><path d="M130.35,117.74a17.46,17.46,0,0,1-3.59-2.71,2.84,2.84,0,0,0-4,4.08,23,23,0,0,0,4.78,3.58,2.84,2.84,0,0,0,3.86-1.09A2.83,2.83,0,0,0,130.35,117.74Z" fill="#0AA2C0"/><path d="M180.45,127.55c-12.49,0-22.65,12.28-22.65,27.37s10.16,27.37,22.65,27.37,22.64-12.28,22.64-27.37S192.93,127.55,180.45,127.55Zm0,49.06c-9.36,0-17-9.73-17-21.69s7.61-21.69,17-21.69,17,9.73,17,21.69S189.8,176.61,180.45,176.61Z" fill="#0AA2C0"/><path d="M103,139.73c-12.49,0-22.64,12.28-22.64,27.37S90.53,194.46,103,194.46s22.64-12.27,22.64-27.36S115.5,139.73,103,139.73Zm0,49.05c-9.36,0-17-9.73-17-21.68s7.61-21.69,17-21.69,17,9.73,17,21.69S112.37,188.78,103,188.78Z" fill="#0AA2C0"/></svg>
          <a href="" className="text-[#07758b] text-base font-light">Events</a>
          </div> */}
          <div className="sm-cards text-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46"><path d="M206.64,171.38c-21.5-3.11-26.82-17.75-32.45-33.24-1.41-3.88-2.74-7.53-4.34-11C156.63,98.3,145.47,90.84,121.58,88V69.64h1.12a4.2,4.2,0,1,0,0-8.39c-1.28,0-2.64,0-4-.07H118a3.68,3.68,0,0,0-.58-.06,2.21,2.21,0,0,0-.37,0C106.49,61,91.81,61.3,85.83,75,81,86,32.1,184.35,31.61,185.35a4.2,4.2,0,0,0,7.52,3.73c.63-1.26,5.7-11.46,12.52-25.22l14.13,17.08a4.2,4.2,0,1,0,6.47-5.36l-16.52-20,7.42-15,14,17a4.2,4.2,0,0,0,6.47-5.35L67.22,132.39c2.22-4.5,4.43-9,6.57-13.35l13.89,16.78a4.2,4.2,0,0,0,3.24,1.52,4.19,4.19,0,0,0,3.23-6.87L77.86,110.78c3.71-7.57,7.09-14.49,9.78-20l15.58,18.82a4.2,4.2,0,1,0,6.47-5.35l-18-21.78,0,0c.86-1.82,1.5-3.2,1.88-4.08,3.19-7.28,10.14-8.7,19.67-8.79V87.63a4.19,4.19,0,0,0,1.08,8.12c24.08,1.94,34.45,5.45,48,34.86,1.46,3.18,2.73,6.69,4.08,10.39,5.64,15.54,12.67,34.87,39.14,38.69,22.28,3.22,38.46,19.39,38.46,38.46a4.2,4.2,0,1,0,8.39,0C252.29,194.87,233.09,175.2,206.64,171.38Z" fill="#0AA2C0"/><path d="M195.7,183.13c-21.54-3.11-26.85-17.66-32.48-33.07-1.34-3.66-2.72-7.45-4.31-10.92-7.25-15.8-14.45-25.17-23.34-30.37-7.76-4.54-16.58-5.82-27.87-6a2.58,2.58,0,0,0-.4,0l-.28,0c-1.1,0-2.21,0-3.36,0a4.19,4.19,0,0,0-3.77,2.36l-54,111.26a4.2,4.2,0,0,0,1.94,5.61A4.17,4.17,0,0,0,53.42,220L103.1,117.65v100.5a4.2,4.2,0,0,0,8.4,0V111.24c18.31.88,28.16,6.09,39.78,31.41,1.45,3.16,2.71,6.62,4.05,10.29,5.64,15.45,12.66,34.68,39.17,38.5,21.46,3.1,34.28,13.08,34.28,26.71a4.2,4.2,0,1,0,8.4,0C237.18,200,221.67,186.88,195.7,183.13Z" fill="#dbb4ac"/></svg>
          <a href="https://www.google.com/maps/place/Thapar+Pet+Shop/@30.3431617,76.3903489,17z/data=!3m1!4b1!4m6!3m5!1s0x3910291f461023a1:0xed357c6c0ea4c9c0!8m2!3d30.3431571!4d76.3929238!16s%2Fg%2F11p623bk35?entry=tts&shorturl=1" target="_blank" className="text-[#07758b] text-base font-light">Visit us</a>
          </div>
       </div>
      </div>

        </section>

        {/* Section 4 */}
        <section className="section sec-4 py-40">
          <div className="container">
          <div className="happy-page text-center">
            <h3 className="text-3xl mb-2">Over 15,000 happy pet owners have trusted us with their furry friends.</h3>
            <p className="text-base font-lightutton">Trust us with your furry friend and enjoy peace of mind while you're away.</p>
       
           <a className="rounded-full bg-[#0AA2C0] px-6 py-3 text-lg text-white mt-10 inline-block" href="/contact">Get in touch</a>
            </div>
          </div>
        </section>

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default Home
